import '@scss/main';
import '@fortawesome/fontawesome-free/js/all.js';
import MobileMenu from '@modules/mobile-menu';

document.addEventListener('DOMContentLoaded', () => {
  const scrolledListeners = document.querySelectorAll('.js-add-scrolled');

  const updateScrolledState = () => {
    const isScrolled = window.scrollY >= 120;

    scrolledListeners.forEach(el => {
      el.classList.toggle('scrolled', isScrolled);
    });
  };

  window.addEventListener('scroll', updateScrolledState, { passive: true });

  // Run once on load
  updateScrolledState();

  new MobileMenu();

  // Optional: expose for manual triggering after menu open/close
  window.dispatchEvent(new Event('scroll'));
});
